module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Baantjer, H. G. Smittenaar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Albert Cornelis Baantjer is the author of "), _c('I', [_vm._v("DeKok and the Sorrowing Tomcat.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1A56tLa/tc-custom/9781250085047.jpg?1719992026579",
      "alt": "This image is the cover for the book DeKok and the Sorrowing Tomcat"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("DeKok and the Sorrowing Tomcat\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Albert Cornelis Baantjer is the Netherland's most widely read author and his hero DeKok is adored and highly praised. The cases DeKok faces are so real that sometimes he and his creator are thought to be the same person since Baantjer worked as a homicide detective in Amsterdam for twenty-five years. "), _c('br'), _c('br'), _vm._v("In this latest adventure to make it overseas, DeKok investigates the murder of a young conman with whom he used to deal."), _c('br'), _c('br'), _vm._v("On the sand dunes that protect the low lands of the Netherlands, an early morning jogger makes a gruesome discovery-the body of a man with a dagger protruding from his back. The corpse of Peter Geffel, better known as \"Cunning\" Pete, is identified, but the local police cannot find any clues."), _c('br'), _c('br'), _vm._v("When the call goes out to notify other jurisdictions of the discovery, Homicide Detective DeKok feels drawn to the case because he knew the victim. Along with his inseparable side-kick Vledder, DeKok searches the city of Amsterdam for answers. Soon there is another corpse and, unlikely as it may seem, the killing of Cunning Pete is connected to a killing in higher social circles.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Minotaur Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0